<template>
  <div>
    <template v-if="isNewClass !== true && mainClass !== true && secondaryClass !== true">
      <div class="d-flex flex-fill justify-content-center">
        <div class="table-responsive" style="width:1280px;">
          <div class="d-flex flex-column text-left">
            <div>
              <ul>
                <li>您可以設定兩層商品分類 主分類、次分類 ，顯示於網頁左側</li>
                <li>
                  <div class="d-flex">
                    <div>電腦版顯示方式：</div>
                    <b-form-radio name="proSortClassRadio" value="A">游標移到主分類時方彈出次分類</b-form-radio>
                    <b-form-radio name="proSortClassRadio" value="B">直接展開次分類</b-form-radio>
                  </div>
                </li>
                <li>
                  <div class="d-flex">
                    <div>
                      手機版顯示方式：
                    </div>
                    <b-form-checkbox value="accepted" unchecked-value="not_accepted">
                      左側滑出的分類，僅顯示主分類，不顯示次分類
                      <small>(次分類會顯示於網頁中商品列表上方)(次分類數量太多時使用)</small>
                    </b-form-checkbox>
                  </div>
                </li>
                <li>
                  <div class="d-flex">
                    <div>商品列表頁上方，次分類顯示方式：</div>
                    <b-form-radio name="proSortClassRadio2" value="A">使用下拉顯示次分類</b-form-radio>
                    <b-form-radio name="proSortClassRadio2" value="B">直接列表次分類</b-form-radio>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <table class="table table-bordered overflow-auto" style="width:1280px;">
            <thead>
              <tr>
                <th scope="col">
                </th>
                <th scope="col">
                  <div class="c2 d-flex flex-fill justify-content-around align-items-center">
                    <div>
                      商品主分類
                    </div>
                    <div>
                      <button type="button" class="btn btn-primary"
                        @click="isNewClass = true">新增一主分類</button>
                    </div>
                  </div>
                </th>
                <th scope="col">
                  商品次分類
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div class="d-flex flex-column justify-content-center align-items-start">
                    <div>
                      <button type="button" class="btn btn-primary"
                        @click="mainClass = true">編輯主分類</button>
                    </div>
                    <div class="d-flex">
                      {{1}}<a href="#">下移</a>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="d-flex justify-content-between">
                    <div>
                      分類一
                    </div>
                    <div>
                      <a href="#">替代圖檔</a>
                    </div>
                  </div>
                </td>
                <td>
                  <button type="button" class="btn btn-primary"
                    @click="secondaryClass = true">編輯次分類</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- <div class="d-flex flex-fill justify-content-center">
    <div style="width:1280px;" class="overflow-auto">
      <div class="d-flex flex-column text-left">
        <div>
          <ul>
            <li>您可以設定兩層商品分類 主分類、次分類 ，顯示於網頁左側</li>
            <li>
              <div class="d-flex">
                <div>電腦版顯示方式：</div>
                <b-form-radio name="proSortClassRadio" value="A">游標移到主分類時方彈出次分類</b-form-radio>
                <b-form-radio name="proSortClassRadio" value="B">直接展開次分類</b-form-radio>
              </div>
            </li>
            <li>
              <div class="d-flex">
                <div>
                  手機版顯示方式：
                </div>
                <b-form-checkbox value="accepted" unchecked-value="not_accepted">
                  左側滑出的分類，僅顯示主分類，不顯示次分類
                  <small>(次分類會顯示於網頁中商品列表上方)(次分類數量太多時使用)</small>
                </b-form-checkbox>
              </div>
            </li>
            <li>
              <div class="d-flex">
                <div>商品列表頁上方，次分類顯示方式：</div>
                <b-form-radio name="proSortClassRadio2" value="A">使用下拉顯示次分類</b-form-radio>
                <b-form-radio name="proSortClassRadio2" value="B">直接列表次分類</b-form-radio>
              </div>
            </li>
          </ul>
        </div>
        <div class="d-flex flex-column">
          <div class="proEditTable proSortClassTB d-flex flex-fill">
            <div class="c1 d-flex justify-content-center align-items-center">
              <div>

              </div>
            </div>
            <div class="c2 d-flex flex-fill justify-content-around align-items-center">
              <div>
                商品主分類
              </div>
              <div>
                <button type="button" class="btn btn-primary">新增一主分類</button>
              </div>
            </div>
            <div class="c3 d-flex justify-content-center align-items-center">
              <div>
                商品次分類
              </div>
            </div>
          </div>
          <div class="proEditTable proSortClassTB d-flex flex-fill">
          <div class="c1 d-flex flex-column justify-content-center align-items-start">
            <div>
              <button type="button" class="btn btn-primary">編輯主分類</button>
            </div>
            <div class="d-flex">
              {{1}}<a href="#">下移</a>
            </div>
          </div>
          <div class="c2 d-flex flex-fill justify-content-between align-items-center">
            <div>
              分類一
            </div>
            <div>
              <a href="#">替代圖檔</a>
            </div>
          </div>
          <div class="c3 d-flex justify-content-center align-items-center">
            <div>
              <button type="button" class="btn btn-primary">編輯次分類</button>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div> -->
    </template>
    <template v-else-if="isNewClass === true">
      <div class="row no-gutters">
        <div class="d-flex col-12 justify-content-center">
          <div class="d-flex flex-column" style="width:1280px;">
            <table class="table table-bordered m-0">
              <tbody>
                <tr>
                  <td>商品主分類</td>
                  <td colspan="3">
                    <div class="d-flex">
                      <div>
                        <b-form-input></b-form-input>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>排序</td>
                  <td>
                    <div class="d-flex">
                      <div>
                        <select class="form-control">
                          <option>1</option>
                          <option>2</option>
                          <option>3</option>
                          <option>4</option>
                        </select>
                      </div>
                    </div>
                  </td>
                  <td>主下架</td>
                  <td>
                    <div class="d-flex">
                      <div>
                        <b-form-checkbox name="SortClassCheck-1" value="accepted"
                          unchecked-value="not_accepted">
                          若勾選，不顯示此商品主分類
                        </b-form-checkbox>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="4">
                    <div class="d-flex justify-content-center align-items-center">
                      <span>商品主分類說明</span>
                      <small>（顯示於商品頁最上方）</small>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <ckeditor :editor="editor" v-model="editorData" :config="editorConfig"></ckeditor>
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <td>整個主分類限閱</td>
                  <td>
                    <div class="d-flex flex-column text-left">
                      <div>
                        <ul>
                          <li>一般消費者不可看到本分類，僅開放某些會員等級的人才可以看到此主分類的商品（後台管理時不受此限）</li>
                          <li>必須勾選開放的會員等級此選項才會作用</li>
                        </ul>
                      </div>
                      <div class="d-flex">
                        <div>
                          <b-form-checkbox name="SortClassCheck-2" value="accepted"
                            unchecked-value="not_accepted">
                            啟用
                          </b-form-checkbox>
                        </div>
                        <span class="border bg-secondary">限制閱覽</span>
                      </div>
                      <div>
                        <table class="table table-bordered text-center">
                          <thead>
                            <tr>
                              <th>請勾選開放瀏覽的會員等級</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <div class="d-flex flex-column align-items-start">
                                  <div>
                                    <b-form-checkbox name="SortClassCheck-3" value="accepted"
                                      unchecked-value="not_accepted">
                                      所有會員
                                    </b-form-checkbox>
                                  </div>
                                  <div>
                                    <b-form-checkbox name="SortClassCheck-3" value="accepted"
                                      unchecked-value="not_accepted">
                                      小孩會員
                                    </b-form-checkbox>
                                  </div>
                                  <div>
                                    <b-form-checkbox name="SortClassCheck-3" value="accepted"
                                      unchecked-value="not_accepted">
                                      普通會員
                                    </b-form-checkbox>
                                  </div>
                                  <div>
                                    <b-form-checkbox name="SortClassCheck-3" value="accepted"
                                      unchecked-value="not_accepted">
                                      銅牌會員
                                    </b-form-checkbox>
                                  </div>
                                  <div>
                                    <b-form-checkbox name="SortClassCheck-3" value="accepted"
                                      unchecked-value="not_accepted">
                                      黃金會員
                                    </b-form-checkbox>
                                  </div>
                                  <div>
                                    <b-form-checkbox name="SortClassCheck-3" value="accepted"
                                      unchecked-value="not_accepted">
                                      鑽石會員
                                    </b-form-checkbox>
                                  </div>
                                  <div>
                                    <b-form-checkbox name="SortClassCheck-3" value="accepted"
                                      unchecked-value="not_accepted">
                                      銀色會員
                                    </b-form-checkbox>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>部分欄位限閱</td>
                  <td>
                    <div class="d-flex flex-column text-left">
                      <div>
                        <ul>
                          <li>一般消費者不可看到本分類，僅開放某些會員等級的人才可以看到此主分類的商品（後台管理時不受此限）</li>
                          <li>必須勾選開放的會員等級此選項才會作用</li>
                        </ul>
                      </div>
                      <div>
                        <div class="d-flex">
                          <div>
                            <b-form-checkbox name="SortClassCheck-4" value="accepted"
                              unchecked-value="not_accepted">
                              啟用
                            </b-form-checkbox>
                          </div>
                          <span class="border bg-secondary">限制看商品圖</span>
                        </div>
                        <div class="d-flex">
                          <div>
                            <b-form-checkbox name="SortClassCheck-4" value="accepted"
                              unchecked-value="not_accepted">
                              啟用
                            </b-form-checkbox>
                          </div>
                          <span class="border bg-secondary">限制看商品簡要說明</span>
                        </div>
                        <div class="d-flex">
                          <div>
                            <b-form-checkbox name="SortClassCheck-4" value="accepted"
                              unchecked-value="not_accepted">
                              啟用
                            </b-form-checkbox>
                          </div>
                          <span class="border bg-secondary">限制看商品詳細說明</span>
                        </div>
                        <div class="d-flex">
                          <div>
                            <b-form-checkbox name="SortClassCheck-4" value="accepted"
                              unchecked-value="not_accepted">
                              啟用
                            </b-form-checkbox>
                          </div>
                          <span class="border bg-secondary">限制看商品留言板</span>
                        </div>
                        <div class="d-flex">
                          <div>
                            <b-form-checkbox name="SortClassCheck-4" value="accepted"
                              unchecked-value="not_accepted">
                              啟用
                            </b-form-checkbox>
                          </div>
                          <span class="border bg-secondary">限制看商品價格</span>
                        </div>
                      </div>
                      <div>
                        <table class="table table-bordered text-center">
                          <thead>
                            <tr>
                              <th>請勾選開放瀏覽的會員等級</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <div class="d-flex flex-column align-items-start">
                                  <div>
                                    <b-form-checkbox name="SortClassCheck-5" value="accepted"
                                      unchecked-value="not_accepted">
                                      所有會員
                                    </b-form-checkbox>
                                  </div>
                                  <div>
                                    <b-form-checkbox name="SortClassCheck-5" value="accepted"
                                      unchecked-value="not_accepted">
                                      小孩會員
                                    </b-form-checkbox>
                                  </div>
                                  <div>
                                    <b-form-checkbox name="SortClassCheck-5" value="accepted"
                                      unchecked-value="not_accepted">
                                      普通會員
                                    </b-form-checkbox>
                                  </div>
                                  <div>
                                    <b-form-checkbox name="SortClassCheck-5" value="accepted"
                                      unchecked-value="not_accepted">
                                      銅牌會員
                                    </b-form-checkbox>
                                  </div>
                                  <div>
                                    <b-form-checkbox name="SortClassCheck-5" value="accepted"
                                      unchecked-value="not_accepted">
                                      黃金會員
                                    </b-form-checkbox>
                                  </div>
                                  <div>
                                    <b-form-checkbox name="SortClassCheck-5" value="accepted"
                                      unchecked-value="not_accepted">
                                      鑽石會員
                                    </b-form-checkbox>
                                  </div>
                                  <div>
                                    <b-form-checkbox name="SortClassCheck-5" value="accepted"
                                      unchecked-value="not_accepted">
                                      銀色會員
                                    </b-form-checkbox>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="d-flex justify-content-center">
              <div>
                <button type="button" class="btn btn-outline-secondary"
                  @click="isNewClass = false">取消</button>
              </div>
              <div>
                <button type="button" class="btn btn-outline-secondary">確定存檔</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="mainClass === true">
      <div class="row no-gutters">
        <div class="d-flex col-12 justify-content-center">
          <div class="d-flex flex-column" style="width:1280px;">
            <table class="table table-bordered m-0">
              <tbody>
                <tr>
                  <td>商品主分類</td>
                  <td colspan="3">
                    <div class="d-flex">
                      <div>
                        <b-form-input></b-form-input>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>排序</td>
                  <td>
                    <div class="d-flex">
                      <div>
                        <select class="form-control">
                          <option>1</option>
                          <option>2</option>
                          <option>3</option>
                          <option>4</option>
                        </select>
                      </div>
                    </div>
                  </td>
                  <td>主下架</td>
                  <td>
                    <div class="d-flex">
                      <div>
                        <b-form-checkbox name="SortClassCheck-6" value="accepted"
                          unchecked-value="not_accepted">
                          若勾選，不顯示此商品主分類
                        </b-form-checkbox>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="4">
                    <div class="d-flex justify-content-center align-items-center">
                      <span>商品主分類說明</span>
                      <small>（顯示於商品頁最上方）</small>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <ckeditor :editor="editor" v-model="editorData" :config="editorConfig"></ckeditor>
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <td>整個主分類限閱</td>
                  <td>
                    <div class="d-flex flex-column text-left">
                      <div>
                        <ul>
                          <li>一般消費者不可看到本分類，僅開放某些會員等級的人才可以看到此主分類的商品（後台管理時不受此限）</li>
                          <li>必須勾選開放的會員等級此選項才會作用</li>
                        </ul>
                      </div>
                      <div class="d-flex">
                        <div>
                          <b-form-checkbox name="SortClassCheck-7" value="accepted"
                            unchecked-value="not_accepted">
                            啟用
                          </b-form-checkbox>
                        </div>
                        <span class="border bg-secondary">限制閱覽</span>
                      </div>
                      <div>
                        <table class="table table-bordered text-center">
                          <thead>
                            <tr>
                              <th>請勾選開放瀏覽的會員等級</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <div class="d-flex flex-column align-items-start">
                                  <div>
                                    <b-form-checkbox name="SortClassCheck-8" value="accepted"
                                      unchecked-value="not_accepted">
                                      所有會員
                                    </b-form-checkbox>
                                  </div>
                                  <div>
                                    <b-form-checkbox name="SortClassCheck-8" value="accepted"
                                      unchecked-value="not_accepted">
                                      小孩會員
                                    </b-form-checkbox>
                                  </div>
                                  <div>
                                    <b-form-checkbox name="SortClassCheck-8" value="accepted"
                                      unchecked-value="not_accepted">
                                      普通會員
                                    </b-form-checkbox>
                                  </div>
                                  <div>
                                    <b-form-checkbox name="SortClassCheck-8" value="accepted"
                                      unchecked-value="not_accepted">
                                      銅牌會員
                                    </b-form-checkbox>
                                  </div>
                                  <div>
                                    <b-form-checkbox name="SortClassCheck-8" value="accepted"
                                      unchecked-value="not_accepted">
                                      黃金會員
                                    </b-form-checkbox>
                                  </div>
                                  <div>
                                    <b-form-checkbox name="SortClassCheck-8" value="accepted"
                                      unchecked-value="not_accepted">
                                      鑽石會員
                                    </b-form-checkbox>
                                  </div>
                                  <div>
                                    <b-form-checkbox name="SortClassCheck-8" value="accepted"
                                      unchecked-value="not_accepted">
                                      銀色會員
                                    </b-form-checkbox>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>部分欄位限閱</td>
                  <td>
                    <div class="d-flex flex-column text-left">
                      <div>
                        <ul>
                          <li>一般消費者不可看到本分類，僅開放某些會員等級的人才可以看到此主分類的商品（後台管理時不受此限）</li>
                          <li>必須勾選開放的會員等級此選項才會作用</li>
                        </ul>
                      </div>
                      <div>
                        <div class="d-flex">
                          <div>
                            <b-form-checkbox name="SortClassCheck-9" value="accepted"
                              unchecked-value="not_accepted">
                              啟用
                            </b-form-checkbox>
                          </div>
                          <span class="border bg-secondary">限制看商品圖</span>
                        </div>
                        <div class="d-flex">
                          <div>
                            <b-form-checkbox name="SortClassCheck-9" value="accepted"
                              unchecked-value="not_accepted">
                              啟用
                            </b-form-checkbox>
                          </div>
                          <span class="border bg-secondary">限制看商品簡要說明</span>
                        </div>
                        <div class="d-flex">
                          <div>
                            <b-form-checkbox name="SortClassCheck-9" value="accepted"
                              unchecked-value="not_accepted">
                              啟用
                            </b-form-checkbox>
                          </div>
                          <span class="border bg-secondary">限制看商品詳細說明</span>
                        </div>
                        <div class="d-flex">
                          <div>
                            <b-form-checkbox name="SortClassCheck-9" value="accepted"
                              unchecked-value="not_accepted">
                              啟用
                            </b-form-checkbox>
                          </div>
                          <span class="border bg-secondary">限制看商品留言板</span>
                        </div>
                        <div class="d-flex">
                          <div>
                            <b-form-checkbox name="SortClassCheck-9" value="accepted"
                              unchecked-value="not_accepted">
                              啟用
                            </b-form-checkbox>
                          </div>
                          <span class="border bg-secondary">限制看商品價格</span>
                        </div>
                      </div>
                      <div>
                        <table class="table table-bordered text-center">
                          <thead>
                            <tr>
                              <th>請勾選開放瀏覽的會員等級</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <div class="d-flex flex-column align-items-start">
                                  <div>
                                    <b-form-checkbox name="SortClassCheck-10" value="accepted"
                                      unchecked-value="not_accepted">
                                      所有會員
                                    </b-form-checkbox>
                                  </div>
                                  <div>
                                    <b-form-checkbox name="SortClassCheck-10" value="accepted"
                                      unchecked-value="not_accepted">
                                      小孩會員
                                    </b-form-checkbox>
                                  </div>
                                  <div>
                                    <b-form-checkbox name="SortClassCheck-10" value="accepted"
                                      unchecked-value="not_accepted">
                                      普通會員
                                    </b-form-checkbox>
                                  </div>
                                  <div>
                                    <b-form-checkbox name="SortClassCheck-10" value="accepted"
                                      unchecked-value="not_accepted">
                                      銅牌會員
                                    </b-form-checkbox>
                                  </div>
                                  <div>
                                    <b-form-checkbox name="SortClassCheck-10" value="accepted"
                                      unchecked-value="not_accepted">
                                      黃金會員
                                    </b-form-checkbox>
                                  </div>
                                  <div>
                                    <b-form-checkbox name="SortClassCheck-10" value="accepted"
                                      unchecked-value="not_accepted">
                                      鑽石會員
                                    </b-form-checkbox>
                                  </div>
                                  <div>
                                    <b-form-checkbox name="SortClassCheck-10" value="accepted"
                                      unchecked-value="not_accepted">
                                      銀色會員
                                    </b-form-checkbox>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="d-flex justify-content-center">
              <div>
                <button type="button" class="btn btn-outline-secondary"
                  @click="mainClass = false">刪除此分類</button>
              </div>
              <div>
                <button type="button" class="btn btn-outline-secondary"
                  @click="mainClass = false">取消</button>
              </div>
              <div>
                <button type="button" class="btn btn-outline-secondary">確定存檔</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="secondaryClass === true">
      <div class="row no-gutters">
        <div class="d-flex col-12 justify-content-center">
          <div class="d-flex flex-column" style="width:1280px;">
            <div class="d-flex justify-content-center">
              <div>
                <button type="button" class="btn btn-primary"
                  @click="secondaryClass = false">回主分類</button>
              </div>
              <div>
                <button type="button" class="btn btn-primary">新增一次分類</button>
              </div>
            </div>
            <div class="d-flex flex-fill">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>排序</th>
                    <th colspan="2">商品次分類</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>
                      <button type="button" class="btn btn-primary">編輯</button>
                    </td>
                    <td>
                      <div class="d-flex">
                        <div>
                          <span>課程4...</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import '@ckeditor/ckeditor5-build-classic/build/translations/zh';

export default {
  data() {
    return {
      isNewClass: false,
      mainClass: false,
      secondaryClass: false,
      editor: ClassicEditor,
      editorData: '<p></p>',
      editorConfig: {
        language: 'zh',
      },
    };
  },
  methods: {},
};

</script>

<style lang="scss">
  .ck-editor__editable {
    height: 500px !important;
  }

</style>
